import { Injectable } from '@angular/core';
import { BPProfilesOEMDataService, IOEMRelation, IOEMTierStatusOption } from './bp-profiles-oem-data.service';
import { IValueObject } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { util } from '../../../../shared/util';

export interface IOEMParamsId {
  oemId:string;
  distributorId:string;
}

@Injectable()
export class BPProfilesOEMService {
  private _oemRelations:IOEMRelation[] = [];
  private _selectedOEMRelationId:number;

  constructor(
    private bpProfilesOEMDataService:BPProfilesOEMDataService
  ) {
    /**/
  }

  public get oemRelations():IOEMRelation[] {
    return this._oemRelations;
  }

  public set oemRelations(oemRelations:IOEMRelation[]) {
    this._oemRelations = oemRelations;
  }

  public get selectedOEMRelationId():number {
    return this._selectedOEMRelationId;
  }

  public set selectedOEMRelationId(oemRelationId:number) {
    this._selectedOEMRelationId = oemRelationId;
  }

  public toStateParam(oemId:number, distributorId:number):string {
    let param = `${oemId}`;
    if (distributorId) {
      param += `-${distributorId}`;
    }
    return param;
  }

  public fromStateParam(param:string):IOEMParamsId {
    const ids:string[] = param.split('-');
    return {
      oemId: ids[ 0 ],
      distributorId: ids[ 1 ]
    };
  }

  public processTierStatuses(tierStatusOptions:IValueObject[], description?:boolean, formatted?:boolean):IValueObject[] {
    const tierStatuses:IValueObject[] = _.map(util.deepClone(tierStatusOptions), (tierStatus:IValueObject) => {
      return this.formatTierStatus(tierStatus, description, formatted);
    });
    return _.sortBy(tierStatuses, 'id');
  }

  private formatTierStatus(tierStatus:IValueObject, description?:boolean, formatted?:boolean):IValueObject {
    const option:IOEMTierStatusOption = this.bpProfilesOEMDataService.getTierStatusOption(tierStatus);
    if (!(option || option.label)) {
      return;
    }

    tierStatus.value = formatted? `<span class="badge ${option.labelClass}">${option.label}</span> ` : `${option.label + (description ? ' - ' : ' ')}`;
    tierStatus.value += `${description? `${option.longLabel}` : ''}`;

    return tierStatus;
  }

  public clear():void {
    this.oemRelations = undefined;
    this.selectedOEMRelationId = undefined;
  }
}